export enum PermissionName {
  DASHBOARD = 'dashboard',
  ORDER_AND_SHIPMENT = 'order_and_shipment',
  FINANCE = 'finance',
  SUPPORT = 'support',
  WITHDRAW_REMITTANCE = 'withdraw_remittance',
  CREATE_ORDER = 'create_order',
  UPDATE_ORDER = 'update_order',
  BULK_IMPORT_ORDER = 'bulk_import_order',
  DELETE_ORDER = 'delete_order',
  CANCEL_ORDER = 'cancel_order',
  RESOLVE_OR_REQUEST_RTO = 'resolve_or_request_rto',
  REQUEST_PICK_UP = 'request_pick_up',
  PICKUP_TIME_SLOTS = 'pickup_time_slots',
  USER_MANAGEMENT = 'user-management',
  API_TOKEN = 'api_token',
  WEBHOOK = 'webhook',
  NOTIFICATION = 'notification',
  CREATE_TICKET = 'create_ticket',
  ADD_COMMENT = 'add_comment_ticket',
  SOLVE_TICKET = 'solve_ticket',
  VIEW_CLAIMS = 'view_claims',
  FILE_CLAIM = 'file_claim',
  PRODUCT_CATALOG = 'product_catalog',
  CARRIER_MANAGEMENT = 'carrier_management',
  ADVANCE_COD = 'advance_cod',
}

// Carrier permissions are never shown to a merchant (owner 2026-10-28: no
// carrier on any merchant screen). Hidden from display only — a role that
// already holds one keeps it, so saving a role sends the same uids.
export const HIDDEN_PERMISSION_NAMES: readonly string[] = [
  PermissionName.CARRIER_MANAGEMENT,
  'carrier.lock',
];

export enum RuleName {
  OWNER = 'owner',
  ADMIN = 'admin',
}

export interface TeamMember {
  uid: string;
  first_name: string;
  last_name: string;
  email: string | null;
  phone?: string;
  type: string;
  verified_at: string;
  created_at: string;
  updated_at: string;
  deleted_at: string | null;
  avatar: {
    uid: string;
    platform_code: string;
    item_type: string;
    priority: number;
    filename: string;
    extension: string;
    abs_url: string;
    type: string;
    used_as: string;
    created_at: string;
    updated_at: string;
    deleted_at: string | null;
  };
  roles: Role[];
}

export interface Role {
  uid: string;
  name: string;
  description: string | null;
  created_at: string;
  updated_at: string;
  permissions?: Permission[];
}

export interface Permission {
  uid: string;
  name: string;
  description: string | null;
  created_at: string;
  updated_at: string;
}
export interface PermissionResponse {
  object: Permission[];
  code: number;
  message: string;
}

export interface TeamMemberResponse {
  object: TeamMember[];
  code: number;
  message: string;
}
export interface RoleResponse {
  object: Role[];
  code: number;
  message: string;
}

export interface TeamMemberRequest {
  uid?: string;
  first_name: string;
  last_name: string;
  email: string | null;
  phone?: string;
  city_slug: string;
  role_uids: string[];
}

export interface RoleRequest {
  uid?: string;
  name: string;
  description?: string;
  permission_uids: string[];
}
